var INDEX_MASK = 0x7FFFFFFF;  // Mask for 31-bit index (bits 0-30)
var DIMENSION_BIT_MASK = 0x80000000;  // Bit 31 = dimension flag
var MAX_WHITE = 0xFFFFFFFF;  // All white (garbage data from background)

/**
 * @param {Number} raw
 * @returns {VizSliceElement}
 */
function decodeGpuElement(raw, hit = { idx: -1, dim: 0 }) {
    // 31-bit picking encoding:
    // - Bits 0-30: 31-bit node/edge index (1-based)
    // - Bit 31: Dimension flag (0=point/node, 1=edge)

    // Check if it's 0 or garbage data (all white from background).
    if (raw === 0 || raw === MAX_WHITE || raw === undefined) {
        hit.dim = 0;
        hit.idx = -1;
    } else {
        hit.dim = decodeGpuDim(raw);
        hit.idx = decodeGpuIndex(raw);
    }

    return hit;
}

// A function that decodes gpu color data into index
function decodeGpuIndex(raw) {
    // Check if it's 0 or garbage data.
    if (raw === 0 || raw === MAX_WHITE || raw === undefined) {
        return -1;
    }

    // Clear dimension bit (bit 31), then convert from 1-based to 0-based
    var idx = (raw & INDEX_MASK) - 1;
    return idx;
}

// A function that decodes gpu color data into dimension (e.g., node vs edge)
function decodeGpuDim(raw) {
    // Check bit 31 for dimension flag
    // Bit 31 = 0 means node/point (dim=1), Bit 31 = 1 means edge (dim=2)
    var dim = (raw & DIMENSION_BIT_MASK) !== 0 ? 2 : 1;
    return dim;
}

/**
 * returns idx or -1
 * @returns {VizSliceElement}
 */
function hitTest(maps, width, height, x, y, numRenderedSplits, hit = { idx: -1, dim: 0 }) {
    // debug('hit testing', texture);

    var canvasIdx = (height - y) * width + x;
    for (var i = 0; i < maps.length; i++) {
        var raw = maps[i][canvasIdx];

        // Log raw pixel data
        // if (raw === undefined || raw === null) {
        //     console.log(`  Map ${i}: raw=undefined/null`);
        // } else {
        //     var r = raw & 0xFF;
        //     var g = (raw >> 8) & 0xFF;
        //     var b = (raw >> 16) & 0xFF;
        //     var a = (raw >> 24) & 0xFF;
        //     console.log(`  Map ${i}: raw=0x${raw.toString(16)} (${raw}), RGBA=(${r}, ${g}, ${b}, ${a})`);
        // }

        hit = decodeGpuElement(raw, hit);
        if (hit.idx > -1) {
            if (hit.dim === 2) {
                hit.idx = Math.floor(hit.idx / (numRenderedSplits + 1));
            }
            return hit;
        }
    }
    hit.dim = 0;
    return hit;
}

/**
 * hit test by sampling for a hit on circle's perimeter
 * returns idx or -1
 * @returns {VizSliceElement}
 */
function hitTestCircumference(
    maps,
    width,
    height,
    x,
    y,
    r,
    numRenderedSplits,
    hit = { idx: -1, dim: 0 }
) {
    const circumference = r * 2 * Math.PI;
    for (let point = 0; point < circumference; point++) {
        let pointX = Math.round(x + r * Math.cos(point / r));
        let pointY = Math.round(y + r * Math.sin(point / r));
        hit = hitTest(maps, width, height, pointX, pointY, numRenderedSplits, hit);
        if (hit.idx > -1) {
            return hit;
        }
    }
    return hit;
}

/**
 * hit test by sampling for closest hit in area radius r (default to 0)
 * returns idx or -1
 *
 * RenderState * [ String ] * float * float * uint -> {idx: -1 + int, dim: 0 + 1 + 2}
 * where dim: 0 = none, 1 = point, 2 = edge
 * @param {RenderState} state
 * @param {String[]} textures Textures are retina-expanded, x/y are still in CSS-space
 * @returns {VizSliceElement}
 */
function hitTestN(state, textures, x, y, r) {
    var numRenderedSplits = state.config.numRenderedSplits;
    var activeTextures = textures.filter(texture => state.pixelreads[texture]);

    if (!activeTextures.length) {
        // debug('no texture for hit test, escape early');
        return { idx: -1, dim: 0 };
    }

    var SAMPLER = state.config.textures.hitmap;
    var SAMPLE_RATE_WIDTH = SAMPLER.width ? 0.01 * SAMPLER.width.value : 1;
    var SAMPLE_RATE_HEIGHT = SAMPLER.height ? 0.01 * SAMPLER.height.value : 1;

    var canvas = state.gl.canvas;
    //already retina-expanded
    var textureWidth = Math.floor(canvas.width * SAMPLE_RATE_WIDTH);
    var textureHeight = Math.floor(canvas.height * SAMPLE_RATE_HEIGHT);
    var pixelRatio = state.camera.pixelRatio;

    var retinaX = Math.floor(x * pixelRatio * SAMPLE_RATE_WIDTH);
    var retinaY = Math.floor(y * pixelRatio * SAMPLE_RATE_HEIGHT);

    var hit = { idx: -1, dim: 0 };
    var maps = activeTextures.map(texture => new Uint32Array(state.pixelreads[texture].buffer));

    // If no r, just do plain hitTest
    if (!r) {
        return hitTest(maps, textureWidth, textureHeight, retinaX, retinaY, numRenderedSplits, hit);
    }

    //look up to r px away
    for (var offset = 0; offset < r; offset++) {
        hit = hitTestCircumference(
            maps,
            textureWidth,
            textureHeight,
            retinaX,
            retinaY,
            offset + 1,
            numRenderedSplits,
            hit
        );
        if (hit.idx > -1) {
            return hit;
        }
    }
    hit.dim = 0;
    return hit;
}

export { hitTest, hitTestCircumference, hitTestN, decodeGpuIndex, decodeGpuElement };
